<app-breadcrumb></app-breadcrumb>


<div class="row mx-1">
     <div class="col-12">

          En CLAVE te ofrecemos varias opciones para que adquieras tus productos favoritos. Te explicamos a continuación
          cómo puedes realizar tu pedido con nosotros.

          Los pagos seran procesados mediante la pasarela de Openpay.
          
          <ul style="padding-left: 40px;">
               <li>Haz tu orden en línea</li>
               <li>Llámanos por teléfono</li>
               <li>Envíanos tu orden por correo</li>
               <li>Envíanos tu orden por WhatsApp</li>
          </ul>

          <hr>
          <p style="text-align: center;"> HAZ TU ORDEN EN LÍNEA </p>
          <p style="text-align: center;"> La manera más práctica. Localiza y realiza la compra de tu instrumento y
               accesorios favoritos por medio de la página de CLAVE. </p>
          <p>
               La página es muy intuitiva, explorando un poco, encontrarás fácilmente lo que estás buscando y el proceso
               de compra te llevará paso a paso de una forma sencilla hasta el que logres colocar tu orden para
               esperarla en la comodidad de tu casa.
               <br> <br>
               Puedes encontrar el producto que buscas a través de la “barra de menú principal” o por medio del “icono
               del instrumento”, ésta última opción es la manera más sencilla si no estás familiarizado con la página de
               CLAVE. Los iconos de instrumento que aparecen en la página CLAVE de acceso rápido son: Saxofón,
               Clarinete, Trompeta, Trombón, Flauta y Cañas dobles; sin embargo no son todos los instrumentos de aliento
               que puedes encontrar en CLAVE, el resto de instrumentos los puedes localizar en la barra de menú
               principal cuyas instrucciones de búsqueda vienen más adelante.
          </p>
          <br>
          <p style="text-align: center;"> - BÚSQUEDA POR MEDIO DEL ICONO DE INSTRUMENTO - </p>
          <p>
               Para encontrar por ejemplo, un estuche para saxofón alto, lo primero que tienes que hacer es localizar el
               icono de saxofón que se encuentra debajo del slider principal.
               <br> <br>
               Al dar click en el ícono de saxofón se abre una página que muestra 2 opciones: Saxofones y Accesorios
               Saxofón, como el estuche para saxofón es un accesorio del instrumento, das click en Accesorios Saxofón y
               se abre otra página con los estuches para 4 tipos de saxofón; das click en Estuches Saxofón Alto y se
               despliegan todas las opciones de estuches para saxofón alto que tenemos en CLAVE. Ahora puedes dar click
               en los estuches que más te interesen y ver todas sus características. En la guía de compra a través de la
               barra de menú principal, te mostraremos como seleccionar el producto que quieres y te guiaremos a través
               de todo el proceso de compra en línea.
          </p>
          <br>
          <p style="text-align: center;"> - BÚSQUEDA POR MEDIO DE BARRA DE MENÚ PRINCIPAL - </p>

          Esta es la forma más rápida de encontrar el artículo que quieres.
          <br> <br>
          La barra de menú principal, es el menú central de la página de CLAVE, donde puedes encontrar cualquiera de los
          artículos publicados en la página.
          <br> <br>
          La barra principal tiene los menús:
          <br> <br>
          INSTRUMENTOS ALIENTOS MADERA - aquí están agrupados los saxofones, clarinetes, flautas, oboes, fagots y
          armónicas.
          <br>
          INSTRUMENTOS ALIENTOS METAL - aquí están agrupadas las trompetas, trombones, cornos francés, tubas, etc.
          <br>
          ACCESORIOS ALIENTOS MADERA - aquí están agrupados todo tipo de accesorios para saxofones, clarinetes, flautas,
          oboes, fagots y armónicas.
          <br>
          ACCESORIOS ALIENTOS METAL - aquí están agrupados todo tipo de accesorios para trompetas, trombones, cornos
          francés, tubas, etc.
          <br>
          ACCESORIOS EN GENERAL - aquí están agrupados los atriles para partitura, metrónomos y afinadores, refacciones
          de reparación y algo más.
          <br> <br>
          En el ejemplo siguiente te diremos paso a paso cómo encontrar y comprar un estuche para saxofón alto a través
          de la barra del menú principal.
          <br> <br>
          <span style="font-weight: bold;">1 - Localiza en la barra de menú principal la categoría a que pertenece el
               artículo que buscas</span>
          <br> <br>
          El saxofón pertenece a la familia de alientos madera, entonces buscaremos el estuche para saxofón alto en el
          menú ACCESORIOS ALIENTO MADERA. Notarás que al poner el cursor sobre este menú se despliega un sub-menú con
          ACCESORIOS SAXOFÓN, ACCESORIOS CLARINETE, etc. Arrastramos el cursor hasta ACCESORIOS SAXOFÓN y te darás
          cuenta que se despliega otro sub-menú con las opciones CAÑAS SAXOFÓN, BOQUILLAS SAXOFÓN, ESTUCHES SAXOFÓN,
          ABRAZADERAS SAXOFÓN, etc. Arrastramos nuevamente el cursor hasta ESTUCHES SAXOFÓN y se despliega un nuevo
          sub-menú que indica ESTUCHES SAXOFÓN SOPRANO, ESTUCHES SAXOFÓN ALTO, etc. Arrastramos y seleccionamos el menú
          ESTUCHES SAXOFÓN ALTO y se desplegará finalmente la página donde aparecen las fotos y precios de los estuches
          para saxofón que buscamos.
          <br> <br>
          Nota: Este es el proceso si estás realizando la búsqueda en una computadora de escritorio. Si lo haces en un
          dispositivo touch (tablet o teléfono), en lugar de arrastrar el cursor, vas accionando touch en cada menú
          hasta llegar a donde se indica en el ejemplo.
          <br>
          Nota: Si realizas la compra desde tu teléfono, la barra de menú principal en lugar de aparecer en la parte
          central, se localiza en la parte superior derecha de la página principal.
          <br> <br>
          <span style="font-weight: bold;">2 - Selecciona la imagen del artículo que quieres</span>
          <br> <br>
          Una vez que estás en la página donde se muestran las varias opciones de marcas y modelos del artículo que
          buscas, puedes dar click en cada una de las imágenes de los que te gusten más para ver detalles particulares,
          como fotos de los productos, variantes de colores, variantes de medidas, descripción detallada del artículo,
          videos, etc.
          <br> <br>
          Nota que hay ocasiones que en una sola página no caben todas las opciones de una categoría de productos, por
          lo que se agregan otras páginas que puedes seleccionar en la parte inferior dando click en los números de
          página dentro de los cuadrados.
          <br> <br>
          <span style="font-weight: bold;">3 - Selecciona la variación deseada</span>
          <br> <br>
          Suponiendo que el estuche para saxofón alto que te gustó es el modelo Protec Contoured ProPac Estuche Sax
          Alto, das click en esta opción y al abrirse la página de este producto, te darás cuenta que es un producto con
          variaciones de color (puedes elegir entre diferentes colores existentes del mismo producto).
          <br> <br>
          Localiza y pon el cursor sobre el recuadro que dice “Elige una opción” y al dar click sobre el mismo notarás
          que se despliegan las variaciones de color. Dirige el cursor a la variación de tu preferencia y da click en la
          misma.
          <br> <br>
          Al tiempo que das click en la variación deseada notarás que aparece otro recuadro donde puedes elegir la
          cantidad de piezas que deseas del mismo artículo en caso de que fuera más de una. Puedes modificar este número
          utilizando las flechas que aparecen dentro del recuadro para aumentar o disminuir la cantidad, o puedes
          ingresar el número manualmente por medio del teclado numérico de tu dispositivo. Al lado izquierdo de este
          nuevo recuadro, también te puedes dar cuenta si hay existencias de un producto o no. Si hay existencias
          aparecerá al lado izquierdo del recuadro una frase de existencias disponibles en color verde. Junto a este
          recuadro también podrá aparecer el precio de la variación que elegiste en caso de que sea un producto con
          variaciones de diferente precio.
          <br> <br>
          CLAVE te ofrece la posibilidad de solicitar sobre pedido algún producto que de momento no esté disponible
          físicamente en la tienda. Cuando un producto esté agotado surgirá la leyenda “Agotado” y abajo de ésta
          aparecerá el botón de “Solicitar Producto” que puedes seleccionar en su caso.
          <br> <br>
          <span style="font-weight: bold;">4 - Añadir al carrito</span>
          <br> <br>
          Al seleccionar el color deseado notarás que se pondrá en color rojo vívido el botón “Añadir al Carrito“ que
          está justo debajo del recuadro de las variaciones, da click en este botón y habrás añadido el producto a tu
          carrito de compra. Aparecerá un texto que dice “haz añadido exitosamente el producto a tu carrito”. Si es el
          único artículo que necesitas, en este punto, puedes pasar a la etapa de concluir tu compra dando click en
          recuadro “Ver Carrito” en la sección verde arriba de la foto del producto, o bien en la parte superior de la
          página de CLAVE, donde aparece el icono del carrito en el recuadro amarillo, junto con la cantidad de
          productos añadidos y el total de tu compra. Si deseas seguir comprando, continúa navegando hasta encontrar
          todos los productos que necesites y añadirlos de uno en uno al carrito con el mismo proceso.
          <br> <br>
          Nota: Para solicitar un producto que esté agotado o algún producto que desees pero que no aparezca en la
          página de CLAVE, da click en el botón de “Solicitar Producto” e inmediatamente aparecerá un formulario. Sigue
          las instrucciones de llenado y da click en el botón “Enviar“, te contactaremos a la brevedad para darte
          información sobre la forma de adquirir el producto que realmente deseas.
          <br> <br>
          <span style="font-weight: bold;">5 - Finalizar compra</span>
          <br> <br>
          Una vez que tienes todos los artículos que deseas añadidos a tu carrito y diste click en el icono amarillo del
          carrito o en el botón de “Ver carrito“, aparecerá la página de tu carrito de compra. En esta página tienes aún
          la opción de modificar las cantidades de cada artículo que elegiste, borrar algún artículo que no deseas y
          seleccionar entre las diferentes paqueterías y tipos de envío que ofrece CLAVE.
          <br> <br>
          Puedes eliminar un artículo dando click en la X al lado izquierdo del producto a eliminar. (Recuerda dar click
          en “Actualizar carrito” cuando aumentes o disminuyas la cantidad de artículos).
          <br> <br>
          En este punto puedes calcular el costo de envío dando click en “Calcular envío”. Elige tu país, provincia y
          código postal, después da click en “Actualizar totales” y te aparecerán las opciones de envío y precios.
          <br> <br>
          Cuando estés listo, procede a dar click en el botón “Finalizar Compra”.
          <br> <br>
          Si es la primera vez que compras en CLAVE y no has registrado una cuenta, da click en el botón “Datos de
          compra” o “Continuar como invitado”
          <br> <br>
          <span style="font-weight: bold;">a) Datos compra</span>
          <br> <br>
          Aparece el primer formulario donde llenas diversos recuadros con tus datos de contacto. Arriba de cada
          recuadro está la indicación de la información a ingresar.
          <br> <br>
          Es importante llenar todos los recuadros con asterisco rojo * que están marcados como obligatorios, pues son
          muy importantes para que tu compra llegue oportunamente hasta donde quieras recibirla. Si no está lleno algún
          recuadro obligatorio, por seguridad, el sistema no te dejará pasar a la siguiente fase. Cuando esté toda la
          información ingresada, da click en el botón de la parte inferior derecha que dice “siguiente”, o bien, da
          click en la barra superior en el recuadro que dice “envío”.
          <br> <br>
          Nota: Es importante que cuentes con un correo válido y lo ingreses en este formulario, pues es aquí a donde te
          enviaremos la confirmación de tu compra y es también el medio principal de contacto para cualquier detalle de
          tu pedido.
          <br>
          Nota: En este formulario también aparece la opción de crear una cuenta, al dar click en el cuadrado de esta
          opción, aparece un recuadro para ingresar una contraseña que solo tu sepas. Esto te sirve para en futuras
          compras no tener que ingresar otra vez todos tus datos de compra en caso de que fueran los mismos.
          <br> <br>
          <span style="font-weight: bold;">b) Envío</span>
          <br> <br>
          En esta sección puedes ingresar una dirección diferente en caso de que la persona que compra sea diferente a
          la persona que recibe el producto. Por ejemplo, si tu estás comprando pero quieres enviar el producto a la
          dirección de un familiar o amigo que es diferente a la tuya, puedes ingresar los datos de la nueva dirección
          en esta sección de la misma forma que lo hiciste en la sección de datos de compra. Si es el caso, solo activa
          el recuadro que está a la izquierda de la frase “Enviar a una dirección diferente” y aparecerá el formulario.
          Si envías a la misma dirección de los datos de compra, solo deja sin activar este recuadro.
          <br> <br>
          En la parte inferior de esta sección de envío está el recuadro donde puedes ingresar instrucciones especiales
          sobre tu pedido, por ejemplo, notas especiales para la entrega, detener tu pedido para enviarlo en una fecha
          específica, o cualquier situación que quieras dejar en claro. Si no deseas agregar nada, déjalo en blanco.
          Para continuar a pagar, da click en el botón de la parte inferior derecha que dice “siguiente” o bien da click
          en la barra superior en el recuadro que dice “Pago”.
          <br> <br>
          <span style="font-weight: bold;">c) Pago</span>
          <br> <br>
          Esta es la última página para finalizar tu compra. En ella aparece el resumen de tu pedido donde puedes
          revisar que los artículos y cantidades sean correctas.
          <br> <br>
          Aquí también puedes seleccionar o cambiar la paquetería y el tipo de envío dando click en el círculo que está
          al lado izquierdo de cada opción. Justo abajo de la sección de envíos aparece el total de tu orden, que es
          justo lo que vas a pagar por tus productos y envío.
          <br> <br>
          Al final vienen las opciones de pago. CLAVE ofrece 3 opciones de pago y puedes elegir la que más se te
          facilite.
          <br> <br>
          Paypal - Paypal es uno de los sistemas mas confiables en el mundo para hacer pagos en línea. Si no conoces el
          sistema de pago por Paypal y quieres saber más del tema, puedes dar click en la frase ¿Qué es Paypal? que está
          al lado derecho de la opción. Si tienes cuenta con Paypal y quieres utilizar este método de pago, solo da
          click en el botón rojo de la parte inferior derecha que dice “Ir a Paypal”.
          <br> <br>
          Pago con tarjeta de crédito o débito - Puedes utilizar esta opción si tienes una tarjeta bancaria de débito o
          crédito. Al seleccionar esta opción (dando click en el círculo al lado izquierdo de la misma), aparece un
          formulario para llenar con los datos de tu tarjeta. El sistema de pagos de CLAVE acepta prácticamente
          cualquier tarjeta de débito o crédito de cualquier banco. El formulario es muy claro y solo hay que seguir las
          instrucciones de llenado. Cabe decir que este sistema es el mas práctico y rápido para comprar en línea.
          Cuando hayas llenado el formulario con los datos correctos de tu tarjeta, solo hay que dar click en el botón
          rojo “Realizar el Pedido” en la parte inferior derecha. Aparecerá una página de confirmación de compra, donde
          dice que tu pedido ha sido realizado con éxito y ¡LISTO!, solo tienes que esperar a recibir tu orden en la
          dirección de envío que ingresaste.
          <br> <br>
          Te llegará la confirmación de tu orden al correo electrónico que ingresaste en el formulario, a este correo
          también te llegará el número de guía de la paquetería que seleccionaste una vez que haya salido físicamente el
          paquete hacia la dirección que ingresaste.
          <br> <br>
          Nota: Si al momento de realizar el pedido aparece que hay algún problema con la tarjeta, revisa que los datos
          que ingresaste sean correctos o llámanos a los teléfonos de contacto para ayudarte a solucionar la situación.
          <br>
          Nota: El Código de seguridad o CVC, son los 3 dígitos que se encuentran al reverso de tu tarjeta en el lado
          derecho de donde va la firma.
          <br> <br>
          Pago en efectivo en tiendas de conveniencia - Esta opción la puedes seleccionar si no tienes o no quieres
          utilizar una tarjeta bancaria para pagar tu orden. Con este método puedes imprimir un recibo a través de esta
          página e ir y pagar en efectivo en alguna tienda afiliada donde se te facilite hacerlo.
          <br> <br>
          Para utilizar esta opción de pago, da click en el círculo al lado izquierdo de la misma. Se despliegan las
          instrucciones para hacer el pago. Aparecen iconos de algunas de las tiendas donde puedes pagar, pero si
          quieres conocer todas las tiendas donde puedes pagar en efectivo, da click en la frase abajo que dice
          “Consulta las tiendas afiliadas”.
          <br> <br>
          Para realizar tu pedido solo tienes que dar click en el botón rojo de la parte inferior derecha “Realizar el
          Pedido”, imprimir el recibo y llevarlo a la tienda que prefieras. (Encontrarás también las instrucciones en el
          recibo de pago). Inmediatamente después de realizar tu pago te enviaremos un correo electrónico con la
          confirmación de pago, a este correo también te llegará el número de guía de la paquetería que seleccionaste
          una vez que haya salido físicamente el paquete hacia la dirección que ingresaste.
          <br> <br>
          <br>
          <div class="card bg-light my-3">
               <div class="card-header">Nota Importante</div>
               <div class="card-body">
                 <span class="card-title">Llamanos</span>
                 <p></p>
                 <p class="card-text">Si quieres realizar tu orden en la pagina pero tienes dudas en cualquier momento del proceso, nos puedes marcar al teléfono de la tienda. Con gusto te ayudaremos a concluir tu orden.</p>
                 <p><strong>Teléfono de contacto:</strong> (492) 92 29639.</p>
                 <p><strong>Horarios de atención:</strong> Lunes a viernes de 10 am a 7 pm - Sábados 10 a 3 pm.</p>
               </div>
          </div>
          <hr>
          <br>
          <p style="text-align: center;"> LLÁMANOS POR TELÉFONO </p>
          <p>
               ¡No te limites para hacer tu orden!
               <br> <br>
               Si no estás familiarizado con internet o se te hace complicado colocar tu orden a través de la página,
               puedes llamarnos en cualquier momento para colocar tu orden vía telefónica.
               <br> <br>
               Te sugerimos de todas formas que navegues por la página, pues aquí podrás ver fotos, descripciones,
               precios y todas las opciones disponibles que tiene CLAVE en tu instrumento. Sin embargo, si decides hacer
               tu orden vía telefónica, llámanos, con gusto crearemos el pedido por ti. Puedes pagar tu orden vía
               telefónica con la tarjeta bancaria que tengas, o te podemos proporcionar instrucciones para que vayas a
               un banco o establecimiento para depositar en efectivo.
               <br> <br>
               Recuerda que en CLAVE todos somos músicos como tú y podemos asesorarte.
               <br> <br>
               Teléfono de contacto: (492) 92 29639.
               <br>
               Horarios de atención: Lunes a viernes de 10 am a 7 pm - Sábados 10 a 3 pm.
          </p>
          <hr>
          <br>
          <p style="text-align: center;"> ENVÍANOS TU ORDEN POR CORREO </p>
          <p>
               Si eres de las personas que se sienten cómodas trabajando en su correo electrónico, nos puedes enviar un
               correo con tu orden a ventas&#64;claveinstrumentos.com. También puedes enviarnos un correo en la sección
               de “Contáctanos” (parte inferior de la página principal), dando click en el icono de correo. Se despliega
               un formulario que tienes que llenar y enviarnos. Te responderemos con gusto.
               <br> <br>
               Te sugerimos de todas formas que navegues por la página, pues aquí podrás ver fotos, descripciones,
               precios y todas las opciones disponibles que tiene CLAVE en tu instrumento.
          </p>
          <hr>
          <br>
          <p style="text-align: center;"> ENVÍANOS TU ORDEN POR WHATSAPP </p>
          <p>
               Si se te facilita escribirnos por WhatsApp y decirnos que productos quieres, puedes agregarnos y
               escribirnos al número (492) 493 4968, te responderemos también por este medio con la información que
               necesitas.
               <br> <br>
               Te sugerimos de todas formas que navegues por la página, pues aquí podrás ver fotos, descripciones,
               precios y todas las opciones disponibles que tiene CLAVE para tu instrumento.
               <br> <br>
               Horarios de atención: Lunes a viernes de 10 am a 7 pm - Sábados 10 a 3 pm
          </p>

     </div>
</div>